<template>
    <header v-if="$route.path=== `/${path}`" class="msg-header layout-header">
            <!-- <span class="logo">logo</span>
            <span>消息中心</span>
            <span style="color: transparent" class="logo">logo</span> -->
            <!-- <van-nav-bar :title="$route.path==='/message'?'消息中心':'个人中心'"> -->
            <van-nav-bar :title="text">    
                <template #left>
                    <img src="/shopLogo.png" alt="" id="msg-header-img">
                </template>
            </van-nav-bar>
    </header>
</template>
<script>
export default {
    name: "MessageProfileHeader",
    props: ["path", "text"],
    data() {
        return {
           
        }
    }

}
</script>
<style scoped>
/* 消息组件头部 */
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.message-header .logo {
    position: absolute;
    left: 0;
    color: var(--red-light);
    font-size: 20px;
}
.msg-header {
    height: 46px;
}
.msg-header #msg-header-img {
    border-radius: 20px;
    width: 30px;
    height: 30px;
}

.msg-header .van-hairline--bottom::after {
    border-bottom: none;
}
</style>